// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__Ytaqu","spinner":"button_spinner__NDPyP","iconButton":"button_iconButton__xrSks"};